import {navigateTo} from '@typed-router';
import {storeToRefs} from 'pinia';
import {defineNuxtRouteMiddleware, useAsyncData} from '#app';
import {useLazyFeatureFlag} from '@malt/feature-flags';
import {resolveAllowedStepName} from '~/features/advanced-search/funnel/utils/resolveAllowedStep';
import {ADVANCED_SEARCH_CALIBRATION_PAGE_FLAG, getAdvancedSearchWorkflowSteps} from '~/features/advanced-search/funnel/workflow';
import {useAdvancedSearchStore} from '~/features/advanced-search/stores/advancedSearch.store';

export default defineNuxtRouteMiddleware(async (to) => {
    const advancedSearchStore = useAdvancedSearchStore();
    const {advancedSearch} = storeToRefs(advancedSearchStore);

    if (!advancedSearch.value) {
        return;
    }

    if (to.name === 's-advanced-briefId-step') {
        const briefId = to.params.briefId as string;
        const currentStep = to.params.step as string;

        const {data: advancedSearchCalibrationPage} = await useAsyncData(ADVANCED_SEARCH_CALIBRATION_PAGE_FLAG, () =>
            useLazyFeatureFlag(ADVANCED_SEARCH_CALIBRATION_PAGE_FLAG),
        );
        const steps = getAdvancedSearchWorkflowSteps('unified', advancedSearchCalibrationPage.value ?? false);
        const allowedStep = resolveAllowedStepName(steps, currentStep, advancedSearch.value);

        if (currentStep !== allowedStep) {
            return navigateTo(
                {
                    name: 's-advanced-briefId-step',
                    params: {briefId, step: allowedStep},
                },
                {replace: true},
            );
        }
    }
});
